/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Images_Input_Add_ImagesInputs */

const en_admin_resources_images_input_add_images = /** @type {(inputs: Admin_Resources_Images_Input_Add_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const de_admin_resources_images_input_add_images = /** @type {(inputs: Admin_Resources_Images_Input_Add_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen`)
};

const es_admin_resources_images_input_add_images = /** @type {(inputs: Admin_Resources_Images_Input_Add_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir`)
};

const fr_admin_resources_images_input_add_images = /** @type {(inputs: Admin_Resources_Images_Input_Add_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter`)
};

const nl_admin_resources_images_input_add_images = /** @type {(inputs: Admin_Resources_Images_Input_Add_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toevoegen`)
};

/** @type {(inputs: Admin_Resources_Images_Input_Add_ImagesInputs) => LocalizedString} */
const it_admin_resources_images_input_add_images = en_admin_resources_images_input_add_images;

/** @type {(inputs: Admin_Resources_Images_Input_Add_ImagesInputs) => LocalizedString} */
const pt_br2_admin_resources_images_input_add_images = en_admin_resources_images_input_add_images;

/** @type {(inputs: Admin_Resources_Images_Input_Add_ImagesInputs) => LocalizedString} */
const pl_admin_resources_images_input_add_images = en_admin_resources_images_input_add_images;

/** @type {(inputs: Admin_Resources_Images_Input_Add_ImagesInputs) => LocalizedString} */
const hu_admin_resources_images_input_add_images = en_admin_resources_images_input_add_images;

/** @type {(inputs: Admin_Resources_Images_Input_Add_ImagesInputs) => LocalizedString} */
const ro_admin_resources_images_input_add_images = en_admin_resources_images_input_add_images;

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Admin_Resources_Images_Input_Add_ImagesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_images_input_add_images = /** @type {((inputs?: Admin_Resources_Images_Input_Add_ImagesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Images_Input_Add_ImagesInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_images_input_add_images(inputs)
	if (locale === "de") return de_admin_resources_images_input_add_images(inputs)
	if (locale === "es") return es_admin_resources_images_input_add_images(inputs)
	if (locale === "fr") return fr_admin_resources_images_input_add_images(inputs)
	if (locale === "nl") return nl_admin_resources_images_input_add_images(inputs)
	if (locale === "it") return it_admin_resources_images_input_add_images(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_images_input_add_images(inputs)
	if (locale === "pl") return pl_admin_resources_images_input_add_images(inputs)
	if (locale === "hu") return hu_admin_resources_images_input_add_images(inputs)
	return ro_admin_resources_images_input_add_images(inputs)
});
export { admin_resources_images_input_add_images as "admin.resources.images_input.add_images" }